import React from 'react';
import { MapPin, Hand, Sparkles, Lock, Clock, RefreshCcw, Heart } from 'lucide-react';

/**
 * TrustBar
 * Slim, premium credibility strip - placed immediately below the hero.
 * Gold icons, white text, subtle top/bottom hairlines.
 */

const ITEMS = [
  { icon: MapPin, text: 'UK Based' },
  { icon: Hand, text: 'Hand Edited' },
  { icon: Sparkles, text: '4K Ultra HD' },
  { icon: Lock, text: 'Secure Payments' },
  { icon: Clock, text: 'Fast Turnaround' },
  { icon: RefreshCcw, text: 'Free Revisions' },
  { icon: Heart, text: 'Personal Service' },
];

const TrustBar = () => {
  return (
    <section
      className="relative bg-black border-y border-white/10 py-6"
      data-testid="trust-bar"
    >
      {/* Ultra-fine gold accents */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="container mx-auto px-4 lg:px-8">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 md:gap-x-10 lg:gap-x-14">
          {ITEMS.map(({ icon: Icon, text }) => (
            <li
              key={text}
              className="flex items-center gap-2 text-white/85 hover:text-white transition-colors"
            >
              <Icon size={16} className="text-amber-400" strokeWidth={1.75} />
              <span className="text-sm md:text-[15px] tracking-wide">{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustBar;
